import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/info.svg'
import _imports_1 from '@/app/ui/assets/svg/ics_f_warning_triangles.svg'
import _imports_2 from '@/app/ui/assets/svg/reload-red.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-a7ae8d72")

_pushScopeId("data-v-a7ae8d72")
const _hoisted_1 = { class: "rounded-xl cargo-dispute-form bg-white p-4" }
const _hoisted_2 = { class: "rounded-2xl border border-gray-lp-1400 bg-white" }
const _hoisted_3 = { class: "py-2.5 px-5 border-b border-gray-lp-1400 bg-gray-lp-2800 rounded-tr-2xl rounded-tl-2xl flex flex-row items-center" }
const _hoisted_4 = { class: "w-1/2 flex flex-row gap-1 items-center text-black-lp-100" }
const _hoisted_5 = { class: "text-xl font-semibold" }
const _hoisted_6 = { class: "text-sm font-bold" }
const _hoisted_7 = { class: "flex flex-col w-1/2 gap-1" }
const _hoisted_8 = { class: "flex flex-row items-center justify-end text-sm font-bold" }
const _hoisted_9 = { class: "flex flex-row gap-4 items-center text-sm justify-end" }
const _hoisted_10 = { class: "text-blue-lp-700 font-bold" }
const _hoisted_11 = { class: "flex flex-row p-3" }
const _hoisted_12 = { class: "w-1/2 flex flex-row gap-3" }
const _hoisted_13 = { class: "flex flex-col gap-1 w-1/3" }
const _hoisted_14 = { class: "text-xs font-semibold text-gray-lp-300 flex flex-row gap-1 items-center" }
const _hoisted_15 = {
  src: _imports_0,
  style: {"height":"15px"},
  alt: "info"
}
const _hoisted_16 = {
  key: 0,
  class: "text-sm text-red-lp-1200"
}
const _hoisted_17 = { class: "flex flex-col gap-1 w-1/3" }
const _hoisted_18 = { class: "text-xs font-semibold text-gray-lp-300 flex flex-row gap-1 items-center" }
const _hoisted_19 = {
  src: _imports_0,
  style: {"height":"15px"},
  alt: "info"
}
const _hoisted_20 = {
  key: 0,
  class: "text-sm text-red-lp-1200"
}
const _hoisted_21 = { class: "flex flex-col gap-1 w-1/3" }
const _hoisted_22 = { class: "text-xs font-semibold text-gray-lp-300 flex flex-row gap-1 items-center" }
const _hoisted_23 = { class: "text-gray-lp-600 font-semibold" }
const _hoisted_24 = {
  key: 2,
  class: "flex flex-row items-center text-blue-lp-700 text-xs gap-1 pt-1"
}
const _hoisted_25 = /*#__PURE__*/_createVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_26 = { class: "w-1/2 flex flex-row justify-end" }
const _hoisted_27 = {
  class: "flex flex-row items-baseline rounded-xl",
  style: {"width":"max-content","height":"max-content"}
}
const _hoisted_28 = { class: "flex flex-col gap-1" }
const _hoisted_29 = { class: "flex flex-col gap-2 justify-center px-8 bg-gray-lp-2800 py-2 rounded-tl-xl rounded-bl-xl" }
const _hoisted_30 = { class: "flex flex-row gap-1 items-center text-center" }
const _hoisted_31 = {
  src: _imports_0,
  alt: "info",
  style: {"height":"15px"}
}
const _hoisted_32 = {
  key: 1,
  class: "flex flex-row gap-1.5 font-bold text-center items-center justify-center"
}
const _hoisted_33 = {
  key: 0,
  class: "flex flex-row items-center justify-center gap-1"
}
const _hoisted_34 = /*#__PURE__*/_createVNode("img", {
  class: "animate-spin",
  src: _imports_2,
  alt: "loading"
}, null, -1)
const _hoisted_35 = {
  key: 1,
  class: "flex flex-row items-center justify-center text-red-lp-2000 text-xs"
}
const _hoisted_36 = { class: "flex flex-col gap-1" }
const _hoisted_37 = { class: "flex flex-col gap-2 justify-center px-8 bg-gray-lp-2800 py-2 rounded-tr-xl rounded-br-xl" }
const _hoisted_38 = { class: "flex flex-row gap-1 items-center text-center" }
const _hoisted_39 = { class: "flex flex-row gap-1.5 font-bold text-blue-lp-700 text-center items-center justify-center" }
const _hoisted_40 = {
  key: 0,
  class: "flex flex-row items-center justify-center text-red-lp-2000 text-xs"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_InputDimension = _resolveComponent("InputDimension")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_TooltipV2 = _resolveComponent("TooltipV2")!
  const _component_PhotoDispute = _resolveComponent("PhotoDispute")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, _toDisplayString(_ctx.convertDecimal(_ctx.totalReweightPieces)) + " " + _toDisplayString(_ctx.$t("cargoV2.components.cargoDisputeForm.pieces")), 1),
          _createVNode("div", _hoisted_6, " (" + _toDisplayString(_ctx.convertDecimal(_ctx.totalReweightStt)) + " " + _toDisplayString(_ctx.$t("cargoV2.components.cargoDisputeForm.stt")) + ", " + _toDisplayString(_ctx.convertDecimal(_ctx.totalReweightBag)) + " " + _toDisplayString(_ctx.$t("cargoV2.components.cargoDisputeForm.bag")) + ") ", 1)
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("cargoV2.components.cargoDisputeForm.reweighTitle")), 1),
          _createVNode("div", _hoisted_9, [
            _createVNode("div", null, [
              _createTextVNode(_toDisplayString(_ctx.$t("cargoV2.components.cargoDisputeForm.grossWeight")) + " ", 1),
              _createVNode("strong", null, _toDisplayString(_ctx.convertDecimal(_ctx.totalReweighGrossWeights)) + " kg", 1)
            ]),
            _createVNode("div", null, [
              _createTextVNode(_toDisplayString(_ctx.$t("cargoV2.components.cargoDisputeForm.volumeWeight")) + " ", 1),
              _createVNode("strong", null, _toDisplayString(_ctx.convertDecimal(_ctx.totalReweighVolumeWeights)) + " kg", 1)
            ]),
            _createVNode("div", null, [
              _createTextVNode(_toDisplayString(_ctx.$t("cargoV2.components.cargoDisputeForm.chargeableWeight")) + " ", 1),
              _createVNode("span", _hoisted_10, _toDisplayString(_ctx.convertDecimal(_ctx.totalReweighChargeableWeight)) + " kg", 1)
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_11, [
        _createVNode("div", _hoisted_12, [
          _createVNode("div", _hoisted_13, [
            _createVNode("div", _hoisted_14, [
              _createTextVNode(_toDisplayString(_ctx.$t("cargoV2.components.cargoDisputeForm.grossWeightCargo")) + " ", 1),
              _withDirectives(_createVNode("img", _hoisted_15, null, 512), [
                [
                  _directive_tooltip,
                  
                  _ctx.$t('cargoV2.components.cargoDisputeForm.maxGrossWeightCargoTooltip', {
                    cargoType: _ctx.cargoTypeLabel,
                    maxWeight: _ctx.maxGrossText
                  })
                ,
                  void 0,
                  { top: true }
                ]
              ])
            ]),
            _createVNode("div", {
              class: ["grossweight-input flex flex-col gap-1", [{ error: _ctx.isGrossWeightInputError }]]
            }, [
              _createVNode(_component_lp_input, {
                suffix: _ctx.$t('cargoV2.components.common.kgCapital'),
                marginVertical: "my-0",
                customClassSuffix: "suffix",
                placeholder: "0",
                isError: "",
                format: _ctx.formatFloat,
                modelValue: _ctx.actualTotalCargoGrossweigth,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.actualTotalCargoGrossweigth = $event)),
                onChange: _ctx.onChangeGrossWeight,
                disabled: !_ctx.form.bagOrStt.length
              }, null, 8, ["suffix", "format", "modelValue", "onChange", "disabled"]),
              (_ctx.isGrossWeightInputError)
                ? (_openBlock(), _createBlock("div", _hoisted_16, _toDisplayString(_ctx.$t("cargoV2.components.cargoDisputeForm.maxWeight", { maxWeight: _ctx.maxGrossText })), 1))
                : _createCommentVNode("", true)
            ], 2)
          ]),
          _createVNode("div", _hoisted_17, [
            _createVNode("div", _hoisted_18, [
              _createTextVNode(_toDisplayString(_ctx.$t("cargoV2.components.cargoDisputeForm.cargoPieces")) + " ", 1),
              _withDirectives(_createVNode("img", _hoisted_19, null, 512), [
                [
                  _directive_tooltip,
                  
                  _ctx.$t('cargoV2.components.cargoDisputeForm.maxCargoPiecesTooltip', {
                    cargoType: _ctx.cargoTypeLabel,
                    maxPieces: _ctx.maxPiecesText
                  })
                ,
                  void 0,
                  { top: true }
                ]
              ])
            ]),
            _createVNode("div", {
              class: ["pieces-input flex flex-col gap-1", [{ error: _ctx.isPiecesInputError }]]
            }, [
              _createVNode(_component_lp_input, {
                marginVertical: "my-0",
                placeholder: "0",
                format: _ctx.formatNoDecimal,
                modelValue: _ctx.cargoActualPiece,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.cargoActualPiece = $event)),
                onChange: _ctx.onChangePiece,
                disabled: !_ctx.form.bagOrStt.length
              }, null, 8, ["format", "modelValue", "onChange", "disabled"]),
              (_ctx.isPiecesInputError)
                ? (_openBlock(), _createBlock("div", _hoisted_20, _toDisplayString(_ctx.$t("cargoV2.components.cargoDisputeForm.maxPieces", { maxPieces: _ctx.maxPiecesText })), 1))
                : _createCommentVNode("", true)
            ], 2)
          ]),
          _createVNode("div", _hoisted_21, [
            _createVNode("div", _hoisted_22, [
              _createTextVNode(_toDisplayString(_ctx.$t("cargoV2.components.cargoDisputeForm.cargoDimension")) + " ", 1),
              _createVNode("span", _hoisted_23, "(" + _toDisplayString(_ctx.$t("cargoV2.components.cargoDisputeForm.dimension")) + ")/" + _toDisplayString(_ctx.convertDecimal(_ctx.divider)), 1)
            ]),
            (_ctx.form.bagOrStt.length)
              ? (_openBlock(), _createBlock(_component_InputDimension, {
                  key: 0,
                  class: "input-dimension",
                  customStyle: "text-sm",
                  width: _ctx.form.actualDimension.cargoActualWidthDimension,
                  "onUpdate:width": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.actualDimension.cargoActualWidthDimension = $event)),
                  length: _ctx.form.actualDimension.cargoActualLengthDimension,
                  "onUpdate:length": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.actualDimension.cargoActualLengthDimension = $event)),
                  height: _ctx.form.actualDimension.cargoActualHeightDimension,
                  "onUpdate:height": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.actualDimension.cargoActualHeightDimension = $event)),
                  withIcon: false,
                  format: _ctx.formatDimension,
                  onChange: _ctx.onChangeDimension
                }, null, 8, ["width", "length", "height", "format", "onChange"]))
              : (_openBlock(), _createBlock(_component_InputDimension, {
                  key: 1,
                  class: "input-dimension",
                  customStyle: "text-sm",
                  width: 0,
                  length: 0,
                  height: 0,
                  withIcon: false,
                  disabled: !_ctx.form.bagOrStt.length
                }, null, 8, ["disabled"])),
            (!_ctx.isEditDimension)
              ? (_openBlock(), _createBlock("div", _hoisted_24, [
                  _hoisted_25,
                  _createVNode("div", null, _toDisplayString(_ctx.$t("cargoV2.components.cargoDisputeForm.editIfDimensionChanged")), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode("div", _hoisted_26, [
          _createVNode("div", _hoisted_27, [
            _createVNode("div", _hoisted_28, [
              _createVNode("div", _hoisted_29, [
                _createVNode("div", _hoisted_30, [
                  _createTextVNode(_toDisplayString(_ctx.$t("cargoV2.components.cargoDisputeForm.cargoVolumeWeight")) + " ", 1),
                  _withDirectives(_createVNode("img", _hoisted_31, null, 512), [
                    [
                      _directive_tooltip,
                      
                      _ctx.$t('cargoV2.components.cargoDisputeForm.maxCargoVolumeWeightTooltip', {
                        cargoType: _ctx.cargoTypeLabel,
                        maxWeight: _ctx.maxVolumeText
                      })
                    ,
                      void 0,
                      { top: true }
                    ]
                  ])
                ]),
                (_ctx.loading)
                  ? (_openBlock(), _createBlock(_component_Skeleton, {
                      key: 0,
                      height: "2rem"
                    }))
                  : (_openBlock(), _createBlock("div", _hoisted_32, [
                      _createVNode("div", {
                        class: ["text-2xl ", [
                      { 'text-red-lp-2000': _ctx.isVolumeWeightError },
                      { 'text-black-lp-100': !_ctx.isVolumeWeightError }
                    ]]
                      }, _toDisplayString(_ctx.convertDecimal(_ctx.form.actualTotalCargoVolumeweight)), 3),
                      _createVNode("div", {
                        class: ["text-sm", [
                      { 'text-red-lp-2000': _ctx.isVolumeWeightError },
                      { 'text-gray-lp-600': !_ctx.isVolumeWeightError }
                    ]]
                      }, " kg ", 2)
                    ]))
              ]),
              (_ctx.loading)
                ? (_openBlock(), _createBlock("div", _hoisted_33, [
                    _hoisted_34,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("cargoV2.components.cargoDisputeForm.calculating")), 1)
                  ]))
                : (_ctx.isVolumeWeightError)
                  ? (_openBlock(), _createBlock("div", _hoisted_35, _toDisplayString(_ctx.$t("cargoV2.components.cargoDisputeForm.maxWeight", { maxWeight: _ctx.maxVolumeText })), 1))
                  : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_36, [
              _createVNode("div", _hoisted_37, [
                _createVNode("div", _hoisted_38, _toDisplayString(_ctx.$t("cargoV2.components.cargoDisputeForm.cargoChargeableWeight")), 1),
                _createVNode("div", _hoisted_39, [
                  _createVNode("div", {
                    class: ["text-2xl", [
                      { 'text-red-lp-2000': _ctx.errorDisputeCargo.message },
                      { 'text-blue-lp-700': !_ctx.errorDisputeCargo.message }
                    ]]
                  }, _toDisplayString(_ctx.convertDecimal(_ctx.form.cargoTotalCustomChargeableWeight)), 3),
                  _createVNode("div", {
                    class: ["text-sm", [
                      { 'text-red-lp-2000': _ctx.errorDisputeCargo.message },
                      { 'text-blue-lp-700': !_ctx.errorDisputeCargo.message }
                    ]]
                  }, " kg ", 2)
                ])
              ]),
              (_ctx.errorDisputeCargo.message)
                ? (_openBlock(), _createBlock("div", _hoisted_40, [
                    _createTextVNode(_toDisplayString(_ctx.errorDisputeCargo.message) + " ", 1),
                    (_ctx.errorDisputeCargo.tooltip)
                      ? (_openBlock(), _createBlock(_component_TooltipV2, {
                          key: 0,
                          description: _ctx.errorDisputeCargo.tooltip,
                          iconColor: "text-red-lp-100"
                        }, null, 8, ["description"]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    (_ctx.isUploadProofPhoto && (!_ctx.isEdit || !_ctx.isEditFirstLanding))
      ? (_openBlock(), _createBlock(_component_PhotoDispute, {
          key: 0,
          modelValue: _ctx.form.photoProof,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.photoProof = $event))
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ]))
})